import { MENU_STATES } from '../actions/actionTypes';
import { MenuState, MenuStateAction } from '../types';

const initialState: MenuState = {
  menuState: false,
};

const reducer = (
  state: MenuState = initialState,
  action: MenuStateAction
): MenuState => {
  switch (action.type) {
    case MENU_STATES:
      return {
        ...state,
        menuState: action.menuState,
      };
  }
  return state;
};

export default reducer;
